import styled from 'styled-components';

export const StyledIframe = styled('iframe')({
  border: 'none',
  margin: '0px',
  padding: '0px',
});

export const StyledText = styled('div')({
  width: '100%',
  textAlign: 'center',
  paddingLeft: '250px',
  '@media (max-width: 743px)': {
    display: 'none',
  },
  '@media (max-width: 1199px)': {
    textAlign: 'right',
    paddingLeft: '0px',
  },
});

export const StyledUL = styled('ul')({
  listStyleType: 'disc',
  paddingLeft: '20px',
  margin: '10px 0',
  '& li': {
    margin: '5px 0',
  },
});
export const StyledLoaderBox = styled('div')({
  maxWidth: '500px',
  margin: 'auto',
  padding: '24px 12px',
});
